
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import {
    Button, setResponsiveMode
} from "office-ui-fabric-react";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { Row, Col } from "react-flexbox-grid";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faCheckSquare, faCoffee } from '@fortawesome/fontawesome-free-solid';
import Select from 'react-select'

import { getUserLogged } from "../../services/loginClient";
import * as apiClient from "../../services/apiClient";
import Loading from "../Loading/Loading";
import {
    hayCambiosPendientes, setCambiosPendientes, removeCambiosPendientes,
    removeIndiceFila, getIndiceFila, setIndiceFila,
    setMockuserSession, getMockuserSession, removeMockuserSession,
    setPeriodoSession, getPeriodoSession, removePeriodoSession,
    removeFlag, setFlag, getFlag
} from '../Shared/Shared.js';

import '../../custom.css'
import './ReportHours.css'

import ModalMessage from '../Shared/ModalMessage';
import { previousDay } from 'date-fns';


removeFlag('flagValidated');
setFlag('flagValidated', false);
setFlag('isMockuser', false);
setFlag('isMenuColapsado', false);

const ReportHours = (props) => {
    // Limpieza de variables en sessionStorage.
    removeMockuserSession();
    removePeriodoSession();
    // Recuperar parámetros.
    const searchParams = new URLSearchParams('?' + atob(props.location.search.substring(1)));
    setMockuserSession(searchParams.get('mockuser'));
    setPeriodoSession({ periodo_inicio: searchParams.get('periodo_inicio'), periodo_fin: searchParams.get('periodo_fin') });
    

    const constantes = {
        operacion: {
            crear: 'I',
            actualizar: 'U',
            eliminar: 'D'
        },
        estado: {
            abierto: 1,
            cerrado: 2,
            validado: 3,
            sap: 4
        }
    }

    const infoProyecto = React.useRef([]);
    const infoFase = React.useRef([]);
    const infoLabourCode = React.useRef([]);
    const infoCliente = React.useRef([]);
    const infoFecha = React.useRef([]);
    const infoHoras = React.useRef([]);
    const infoComentario = React.useRef([]);

    const showConsoleLogDebug = false;
    const history = useHistory();
    const [userLogged, setUserLogged] = useState(getUserLogged());
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [translations, setTranslations] = useState([]);

    const [persona, setPersona] = useState(null);
    const [mockuser, setMockuser] = useState({ nombre: '', apellidos1: '', apellido2: '' });
    const [isMockuser, setIsMockuser] = useState(false);
    const [period, setPeriod] = useState([]);
    const [periods, setPeriods] = useState([]);
    const [position, setPosition] = useState(0);
    const [disableNextPeriod, setDisableNextPeriod] = useState(false);
    const [disablePreviousPeriod, setDisablePreviousPeriod] = useState(false);
    const [disableAddRow, setDisableAddRow] = useState(false);
    const [disableDeleteRow, setDisableDeleteRow] = useState(true);
    //const [commentReadOnly, setCommentReadOnly] = useState(true);

    const [windowHeight, setWindowHeight] = useState(0);
    const [domLayout, setDomLayout] = useState('normal');    
    const [gridApi, setGridApi] = useState(null);
    const [gridBottomRows, setGridBottomRows] = useState([{ totalHoras: 0 }]);
    const [gridHeight, setGridHeight] = useState(300);
    const [gridHeight_Aux, setGridHeight_Aux] = useState(0);
    const [pageSize, setGridPageSize] = useState(50);

    const [dynamicColumns, setDynamicColumnsGridColumns] = useState([]);
    const [parents, setParents] = useState([]);
    const [childrens, setChildrens] = useState([]);
    const [labourCodes, setLabourCodes] = useState([]);
    const [reports, setReports] = useState([]);

    const [messageTitle, setMessageTitle] = useState("");
    const [messageContent, setMessageContent] = useState("");
    const [messageStatus, setMessageStatus] = useState(false);
    const [messageHeaderBackground, setMessageHeaderBackground] = useState('');

    const language = navigator.language.startsWith('es') ? 'es' : 'en';

    useEffect(() => {
        const GetTranslations = async () => {
            if (showConsoleLogDebug)
                console.log("ReportHours.GetTranslations1()");

            const labels = await apiClient.GetLabelsByFolderAndControllerAndLabelName(language, "TimesheetTasking", "Report", "reportHours");
            const data = await apiClient.GetTranslationsByLabels(language, labels);

            setMessage(navigator.language.startsWith('es') ? 'Cargando...' : 'Loading...');
            setLoading(true);

            setTranslations(data);
        };

        const GetScreenData = async () => {
            if (showConsoleLogDebug)
                console.log("ReportHours.GetScreenData()");

            removeIndiceFila();
            setIndiceFila(0);
            removeCambiosPendientes();
            setCambiosPendientes(false);
            disableBtnCancel(true);
            disableBtnSave(true);

            var req = getReq();
            var persona = await apiClient.GetPersonaData(language, req);

            // Comprobar si hay que usar mockuser.
            var mockuser = { nombre: '', apellido1: '', apellido2: '', sociedad: undefined };

            if ("null" !== req.nPersonalMockuser && req.nPersonalMockuser) {
                var result = await apiClient.IsEmployeeSubordinateOf(language, req);

                if (result.value) {
                    result = await apiClient.GetMockuserData(language, req);
                    mockuser = result.vmPersona;
                    setIsMockuser(true);
                    setFlag('isMockuser', true);
                } else {
                    window.location.replace('/');
                    return;
                }
            }

            var labourCodes = await getLabourCodes();
            var periodos = await apiClient.GetPeriodsBySociety(language, mockuser.sociedad ?? persona.sociedad);
            var mockuser_periodo = getPeriodoSession();
            var currentDate = new Date();
            var disablePreviousPeriod = false;
            var disableNextPeriod = true;

            if (mockuser_periodo.periodo_inicio != null || mockuser_periodo.periodo_inicio != undefined) {
                // Si están parametrizadas las fechas del periodo, entonces utilizo la fecha de inicio
                // para recuperar el periodo especificado.
                currentDate = new Date(mockuser_periodo.periodo_inicio);
            }
            //else {
            //    // En este caso no hay parametrizado periodo alguno, así que busco establecer el periodo
            //    // para la fecha actual.
            //    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDay());
            //}

            var position = periodos.findIndex(per => {
                var fechaInicio = per.fechaInicio;
                var fechaFin = per.fechaFin;

                return currentDate >= new Date(fechaInicio) && currentDate <= new Date(fechaFin);
            });

            // En caso de estar fuera de todos los rangos de periodos,
            // se escoge el periodo más reciente si lo hubiera.
            if (-1 == position && periodos.length > 0) {
                position = periodos.length - 1;
            }

            if (periodos.length <= 1) {
                disablePreviousPeriod = true;
            }

            if (position < periodos.length - 1) {
                disableNextPeriod = false;
            }

            var parents = await apiClient.GetParentsProjectsDataBySociedad(language, mockuser.sociedad ?? persona.sociedad, mockuser.nPersonal ?? persona.nPersonal);
            var parents_projects_vm = [];
            parents.forEach((proyecto, index) => {
                let item = null;

                if (proyecto.esProyectoGeneral) {
                    item = {
                        value: 'PG' + proyecto.id,
                        label: `${proyecto.codigo}`,
                        name: `${proyecto.codigo}`,
                        client: '',
                        client_name: '',
                        idProyectosN2: []
                    }
                } else {
                    item = {
                        value: proyecto.idPep,
                        label: `${proyecto.codigo} ${proyecto.nombre}`,
                        name: proyecto.nombre,
                        client: proyecto.clienteCodigo,
                        client_name: proyecto.clienteNombre,
                        idProyectosN2: proyecto.idProyectosN2.replace(/.$/, "").split(',')
                    };
                }
                item.esProyectoGeneral = proyecto.esProyectoGeneral
                parents_projects_vm.push(item);
            });

            //if (!isEditionClosed(periodos[position])) {
            //    setCommentReadOnly(false);
            //}
            setComentarioReadonly(true);
            let vmImputaciones = await getEmployeeImputations(language, req, periodos[position], parents_projects_vm, mockuser.sociedad ?? persona.sociedad, mockuser.nPersonal ?? persona.nPersonal);
            disableButtonsEditionClosed(periodos[position]);
            console.log(vmImputaciones);
            setPersona(persona);
            setMockuser(mockuser);            
            setDisablePreviousPeriod(disablePreviousPeriod);
            setDisableNextPeriod(disableNextPeriod);
            setLabourCodes(labourCodes);
            setPeriods(periodos);
            setPeriod(periodos[position]);
            setPosition(position);
            setParents(parents_projects_vm);
            setReports(vmImputaciones);
            refreshPinnedRowBottomCount(vmImputaciones);

            setLoading(false);
        };

        const getLabourCodes = async () => {
            var labourCodes = await apiClient.GetLabourCodes(language);
            var catalogo = [];

            labourCodes.forEach((item, index, array) => {
                catalogo.push({
                    value: item.codigo,
                    label: `${item.codigo} ${item.nombre}`,
                    name: item.nombre
                });
            });

            return catalogo;
        }

        const OcultarMenu = () => {
            // Establezco un timeout de 500ms porque de lo contrario no puedo determinar
            // si el menú lateral está o no colapsado.
            setTimeout(() => {
                var isFlagColapsado = getFlag('isMenuColapsado');

                if (!isFlagColapsado) {
                    setFlag('isMenuColapsado', true);

                    if (document.getElementById('sidebar-css').offsetWidth > 100) {                        
                        document.getElementById('menu_open').click();
                    }
                }
            }, 500);
        }

        GetTranslations();
        GetScreenData();
        OcultarMenu();
    }, [getMockuserSession]);

    /********************************************************************************* Configuración tabla */
    const getGridColumns = () => {
        if (showConsoleLogDebug) console.log("ReportHours.getGridColumns()");
        let grid_columns = [
            {
                headerName: '',
                headerComponentParams: '', //{ template: '<i class="fa fa-trash" aria-hidden="true"></i>' },
                textAlign: 'Center',
                field: 'operacion',
                pinned: 'left',
                width: 30,
                editable: false,
                cellRenderer: (field) => {
                    let icono = '';

                    if ('U' == field.data.operacion) {
                        icono = <i class="fa fa-pencil-alt"></i>;
                    } else if ('I' == field.data.operacion) {
                        icono = <i class="fa fa-plus"></i>;
                    } else if ('D' == field.data.operacion) {
                        icono = <i class="fa fa-trash" aria-hidden="true"></i>;
                    }

                    return icono;
                }
            },
            {
                field: "proyecto",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "reportHours.Project")[0].body : "",
                filter: "agTextColumnFilter",
                cellRenderer: (field) => {
                    let pos = null;
                    let index = reports.findIndex(r => r.id == field.data.id);
                    let nombre = (field.data.nombreProyecto) ? field.data.nombreProyecto : '';

                    if (index >= 0 && 'pepPadreIdN1' in reports[index]) {
                        //pos = parents.findIndex(item => item.idProyectosN2.includes(reports[index]?.pepPadreId));
                        pos = parents.findIndex(p => p.value == (reports[index]?.pepPadreIdN1 ?? reports[index]?.pepPadreId));
                    }

                    return (
                        <div title={nombre}>
                            {
                                index >= 0 &&
                                <Select
                                    id="parentProjectSelector"
                                    defaultValue={parents[pos]}
                                    isClearable={true}
                                    isSearchable={true}
                                    isDisabled={isEditionClosed(periods[position]) || field.data.noTieneAccesoProyecto || field.data.filaNoEditable}
                                    options={parents}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: provided => ({ ...provided, zIndex: 5, width: 500 })
                                    }}
                                    classNamePrefix="react-select"
                                    onChange={(newValue) => handleParentProjectChange(newValue, field.node)}
                                />
                            }
                        </div>
                    );
                },
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true
            },
            {
                field: "nombreProyecto",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "reportHours.ProjectName")[0].body : "",
                filter: "agTextColumnFilter",
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    let nombreProyecto = '';

                    if (undefined !== field.data.nombreProyecto) {
                        nombreProyecto = (field.data.nombreProyecto.length > 22) ? `${field.data.nombreProyecto.substr(0, 22)}...` : field.data.nombreProyecto;
                    }

                    return (
                        <span title={field.data.nombreProyecto}>{nombreProyecto}</span>
                    )
                }
            },
            {
                field: "fase",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "reportHours.Phase")[0].body : "",
                filter: "agTextColumnFilter",
                cellRenderer: (field) => {
                    let pos = null;
                    let index = reports.findIndex(r => r.id == field.data.id);
                    let list = [];
                    let nombre = (field.data.nombreFase) ? field.data.nombreFase : '';

                    if (index >= 0 && 'fases' in reports[index]) {
                        list = reports[index].fases;
                    }

                    if (index >= 0 && 'fase' in reports[index]) {
                        pos = list.findIndex(item => item.value === reports[index].fase);
                    }

                    return (
                        <div title={nombre}>
                            {
                                index >= 0 &&
                                <Select
                                    id={"childProjectSelector_" + field.data.id}
                                    defaultValue={list[pos] ?? ''}
                                    isClearable={true}
                                    isSearchable={true}
                                    isDisabled={isEditionClosed(periods[position]) || field.data.noTieneAccesoProyecto || field.data.filaNoEditable}
                                    options={list}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: provided => ({ ...provided, zIndex: 5, width: 500 }),
                                    }}
                                    onChange={(newValue) => handleChildrenProjectChange(newValue, field.node)}
                                    classNamePrefix="react-select"
                                />
                            }
                        </div>
                    );
                },
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true
            },
            {
                field: "nombreFase",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "reportHours.PhaseName")[0].body : "",
                filter: "agTextColumnFilter",
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    let nombreFase = '';

                    if (undefined !== field.data.nombreFase) {
                        nombreFase = (field.data.nombreFase.length > 22) ? `${field.data.nombreFase.substr(0, 22)}...` : field.data.nombreFase;
                    }

                    return (
                        <span title={field.data.nombreFase}>{nombreFase}</span>
                    );
                }
            },
            {
                field: "codigoLabourCode",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "reportHours.LabourCode")[0].body : "",
                filter: "agTextColumnFilter",
                cellRenderer: (field) => {
                    let pos = null;
                    let index = reports.findIndex(r => r.id == field.data.id);
                    let name = '';

                    if (index >= 0 && 'codigoLabourCode' in reports[index] && labourCodes.length > 0) {
                        pos = labourCodes.findIndex(item => item.value === reports[index]?.codigoLabourCode);
                    }

                    if (null != pos && -1 != pos) {
                        name = (-1 != pos) ? labourCodes[pos].name : '';
                    }

                    return (
                        <div title={name}>
                            {
                                index >= 0 &&
                                <Select
                                    id="labourCodeSelector"
                                    defaultValue={labourCodes[pos]}
                                    isClearable={true}
                                    isSearchable={true}
                                    isDisabled={isEditionClosed(periods[position]) || reports[index].esProyectoGeneral || field.data.noTieneAccesoProyecto || field.data.filaNoEditable}
                                    options={labourCodes}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: provided => ({ ...provided, zIndex: 5, width: 500 })
                                    }}
                                    classNamePrefix="react-select"
                                    onChange={(newValue) => handleLabourCodeChange(newValue, field.node)}
                                />
                            }
                        </div>
                    );
                },
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true
            },
            {
                field: "totalHoras",
                headerName: '',// translations.length > 0 ? translations.filter(translations => translations.label == "reportHours.TotalHours")[0].body : "",
                headerComponentParams: { template: `<span style="white-space:break-spaces;text-align:center;">${translations.length > 0 ? translations.filter(translations => translations.label == "reportHours.TotalHours")[0].body : ""}</span>` },
                filter: "agTextColumnFilter",
                width: 100,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    if ('id' in field.data) {
                        let index = reports.findIndex(r => r.id == field.data.id);
                        field.data.totalHoras = field.data.inputs.reduce((totalLinea, item) => { return totalLinea + item.input }, 0);

                        return (
                            <div class="text-center"><span id={`fila_${field.data.id}`}>{field.data.totalHoras}</span></div>
                        );
                    } else {
                        let reportsTotalHours = getReportsTotalHours();

                        return (
                            <div class="text-center"><span id='fila_resumen_horas_totales'>{reportsTotalHours.toFixed(2)}</span></div>
                        );
                    }

                },
            }
        ];

        let dynamicColumns = generateColumns(language, new Date(period.fechaInicio), new Date(period.fechaFin));

        return [...grid_columns, ...dynamicColumns];
    }

    const generateColumns = (language, startDate, endDate) => {
        if (showConsoleLogDebug) console.log("ReportHours.generateColumns()");
        const columns = [];
        const currentDate = new Date(startDate);
        let lang = language == 'es' ? 'es-ES' : 'en-US';

        while (currentDate <= endDate) {
            const day = currentDate.toLocaleDateString(lang, { weekday: 'short' });
            const dayNumber = formatDateNumber(currentDate.getDate());
            const monthNumber = formatDateNumber(currentDate.getMonth() + 1);
            const yearNumber = currentDate.getFullYear();

            const column = {
                field: `${yearNumber}-${monthNumber}-${dayNumber}`,
                //headerName: `${day} ${dayNumber}/${monthNumber}`,
                headerName: '',
                headerComponentParams: { template: `<span style="white-space:break-spaces;text-align:center;">${day} ${dayNumber}/${monthNumber}</span>` },
                width: 70,
                resizable: true,
                editable: false,
                cellRenderer: (field) => {
                    if (showConsoleLogDebug)
                        console.log("ReportHours.cellRenderer()");

                    const regex = /^(\d+\.?\d{0,2}|\.\d{1,2})$/;
                    const pinned = field.node.rowPinned;
                    let index = reports.findIndex(r => r.id == field.data.id);
                    let valor = 0;
                    let suma_resumen = 0;
                    let noTieneAccesoProyecto = false;
                    let filaNoEditable = false;

                    if (index !== -1 && reports[index].inputs && Array.isArray(reports[index].inputs)) {
                        //let fecha = yearNumber + '-' + monthNumber + '-' + dayNumber;
                        noTieneAccesoProyecto = reports[index].noTieneAccesoProyecto ?? false;
                        filaNoEditable = reports[index].filaNoEditable ?? false;
                        let input = reports[index].inputs.find(objeto => objeto.date === field.colDef.field);

                        if (input) {
                            valor = input.input;
                            //noTieneAccesoProyecto = input.noTieneAccesoProyecto
                        }
                    }

                    if (reports.length > 0) {
                        suma_resumen = getTotalHoursByDate(field.colDef.field);
                    }

                    const handleChange = (event) => {
                        if (showConsoleLogDebug)
                            console.log("ReportHours.generateColumns().handleChange()");

                        let newValue = (event.target.value.length > 0) ? event.target.value : 0;
                        const isNumeric = regex.test(newValue);
                        const isInRange = newValue >= 0 && newValue <= 24;

                        if (isNumeric && isInRange) {
                            // Para limpiar los ceros por la izquierda.
                            event.target.value = Number(event.target.value);

                            let i = reports.findIndex(r => r.id == field.data.id);
                            let report = reports[i];
                            let reportInput = report.inputs.find(objeto => objeto.date === field.colDef.field);

                            if (!checkTotalHoursColumnDay(reportInput, newValue, field.colDef.field)) {
                                return;
                            }

                            if (reportInput) {
                                reportInput.input = Number(newValue);
                                reportInput.operacion = (constantes.operacion.crear != reportInput.operacion) ? constantes.operacion.actualizar : constantes.operacion.crear;
                            }
                            else {
                                if (0 == Number(newValue)) {
                                    // Aún no existe el objeto de la imputación y se está queriendo poner cero horas. 
                                    // No permito crear una imputación con cero horas. ¿Cuál es el sentido de crear una imputación sin horas?
                                    return;
                                }

                                reportInput = {
                                    id: getNewId(reports), //report.id + field.colDef.field.replaceAll('-', ''),
                                    date: field.colDef.field,
                                    input: Number(newValue),
                                    operacion: constantes.operacion.crear,
                                    cliente: mockuser.sociedad ?? persona.sociedad
                                }

                                reports[i].inputs.push(reportInput);                                

                                if (-1 == infoComentario.current.inputId) {
                                    // Para poder actualizar el comentario de una celda cuyo id es -1, pues aún no existe su objeto
                                    // 'input' en la fila.
                                    infoComentario.current.inputId = reportInput.id;
                                }
                            }

                            report.operacion = (constantes.operacion.crear != report.operacion) ? constantes.operacion.actualizar : constantes.operacion.crear;
                            infoHoras.current.innerHTML = (undefined == reportInput) ? '0,00' : parseFloat(reportInput.input).toFixed(2);

                            let suma_total_horas = getTotalHoursOfReportI(i);
                            let suma_resumen = getTotalHoursByDate(field.colDef.field);

                            document.getElementById(`fila_${field.data.id}`).innerHTML = suma_total_horas.toFixed(2);
                            document.getElementById(yearNumber + "-" + monthNumber + "-" + dayNumber + "_resumen").value = parseFloat(Number(suma_resumen).toFixed(2));

                            gridApi.refreshCells({ rowNodes: [reports[i]], force: true });
                            refreshPinnedRowBottomCount();
                            disableBtnCancel(false);
                            //disableBtnSave(false);
                            ajustarEstadoBotonSave(reports);
                            ajustarEstadoBotonAdd(reports);
                            setCambiosPendientes(true);
                        }
                    };

                    const handleOnFocus = (event) => {
                        if (showConsoleLogDebug)
                            console.log("ReportHours.generateColumns().handleOnFocus()");

                        //setCommentReadOnly(isEditionClosed(periods[position]));
                        setComentarioReadonly(isEditionClosed(periods[position]))

                        let i = reports.findIndex(r => r.id == field.data.id);
                        let report = reports[i];
                        let reportInput = report.inputs.find(objeto => objeto.date === field.colDef.field);

                        console.log("input");
                        console.log(reports);

                        showRowData(report);
                        infoHoras.current.innerHTML = (undefined == reportInput) ? '0,00' : parseFloat(reportInput.input).toFixed(2);
                        infoFecha.current.innerHTML = (undefined == reportInput) ? formatDateString(new Date(field.colDef.field)) : formatDateString(new Date(reportInput.date));
                        infoComentario.current.value = (undefined == reportInput || undefined === reportInput.comentario) ? '' : reportInput.comentario;

                        // Guardo en el textarea la información del input, para poder después actualizar el comentario si se modifica.
                        infoComentario.current.idReport = field.data.id;
                        infoComentario.current.inputId = (undefined == reportInput) ? -1 : reportInput.id;

                        if (showConsoleLogDebug) console.log(reportInput);
                    };

                    if (pinned != "bottom") {
                        return (
                            <div >
                                <input
                                    id={yearNumber + "-" + monthNumber + "-" + dayNumber + "_input_" + field.data.id}
                                    key={yearNumber + "-" + monthNumber + "-" + dayNumber + "_input_" + field.data.id}
                                    class={(isEditionClosed(periods[position])) ? "color-fondo-gris grid-editable-report-input text-center" : "grid-editable-report-input text-center"}
                                    type="number"
                                    min="0"
                                    max="24"
                                    step="0.01"
                                    readOnly={isEditionClosed(periods[position])}
                                    onChange={handleChange}
                                    onClick={handleOnFocus}
                                    value={valor}
                                    
                                />
                                {/*<input type="number" min="0" max="24" step="0.01" disabled={false} onChange={(newValue) => handleChange(newValue, field.node)} value={value} />*/}
                            </div>
                        );
                    }
                    else {
                        return (
                            <div>
                                <input
                                    id={yearNumber + "-" + monthNumber + "-" + dayNumber + "_resumen"}
                                    class="grid-no-editable-resumen-row text-center"
                                    type="text"
                                    min="0"
                                    max="24"
                                    step="0.01"
                                    disabled={true}
                                    value={suma_resumen} />
                            </div>
                        );
                    }
                },
            };

            columns.push(column);
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return columns;
    };

    const getNewId = (reports) => {
        let id = 1;
        if (reports.map(p => p.inputs).reduce(function (inputs, input) { return inputs.concat(input); }).length > 0) {
            id = Math.max(...(reports.map(p => p.inputs).reduce(function (inputs, input) { return inputs.concat(input); }).map(i => i.id))) + 1;
        } 

        return id;
    }

    const onGridReady = params => {
        if (showConsoleLogDebug) console.log("ReportHours.onGridReady()");
        setGridApi(params.api);
    };
    /************************************************************************** Fin configuración tabla */

    /************************************************************************** Eventos botones */
    const goToPreviousWeek = async () => {
        if (showConsoleLogDebug) console.log("ReportHours.goToPreviousWeek()");

        if (hayCambiosPendientes()) {
            showThereArePendingChanges();
            return;
        }

        setMessage(navigator.language.startsWith('es') ? 'Cargando...' : 'Loading...');
        setLoading(true);

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        setDynamicColumnsGridColumns([]);
        cleanShowedInputData();
        setFlag('flagValidated', false);

        var req = getReq();
        var pos = position;
        pos = pos - 1;

        var periodo = periods[pos];

        var disablePreviousPeriod = false;
        var disableNextPeriod = false;

        if (pos == 0)
            disablePreviousPeriod = true;

        if (pos == periods.length || periods.length <= 1)
            disableNextPeriod = true;

        var dynamicColumns = generateColumns(language, new Date(periodo.fechaInicio), new Date(periodo.fechaFin));
        var parents = await apiClient.GetParentsProjectsDataBySociedad(language, mockuser.sociedad ?? persona.sociedad, mockuser.nPersonal ?? persona.nPersonal);
        var parents_projects_vm = [];
        parents.forEach((proyecto) => {
            let item = null;

            if (proyecto.esProyectoGeneral) {
                item = {
                    value: 'PG' + proyecto.id,
                    label: `${proyecto.codigo}`,
                    name: `${proyecto.codigo}`,
                    client: '',
                    client_name: '',
                    idProyectosN2: []
                }
            } else {
                item = {
                    value: proyecto.idPep,
                    label: `${proyecto.codigo} ${proyecto.nombre}`,
                    name: proyecto.nombre,
                    client: proyecto.clienteCodigo,
                    client_name: proyecto.clienteNombre,
                    idProyectosN2: proyecto.idProyectosN2.replace(/.$/, "").split(',')
                };
            }

            parents_projects_vm.push(item);
        });
        let vmImputaciones = await getEmployeeImputations(language, req, periodo, parents_projects_vm, mockuser.sociedad ?? persona.sociedad, mockuser.nPersonal ?? persona.nPersonal);

        //setCommentReadOnly(isEditionClosed(periodo));
        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        cleanShowedInputData();

        disableButtonsEditionClosed(periodo);
        setPosition(pos);

        setDisablePreviousPeriod(disablePreviousPeriod);
        setDisableNextPeriod(disableNextPeriod);

        setPeriod(periodo);
        setDynamicColumnsGridColumns(dynamicColumns);

        setReports(vmImputaciones);
        refreshPinnedRowBottomCount(vmImputaciones);

        setLoading(false);
    };

    const goToNextWeek = async () => {
        if (showConsoleLogDebug)
            console.log("ReportHours.goToNextWeek()");

        if (hayCambiosPendientes()) {
            showThereArePendingChanges();
            return;
        }

        setMessage(navigator.language.startsWith('es') ? 'Cargando...' : 'Loading...');
        setLoading(true);

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        setDynamicColumnsGridColumns([]);
        cleanShowedInputData();
        setFlag('flagValidated', false);

        var req = getReq();
        var pos = position;
        pos = pos + 1;

        var periodo = periods[pos];

        var disablePreviousPeriod = false;
        var disableNextPeriod = false;

        if (pos == 0)
            disablePreviousPeriod = true;

        if (pos == periods.length - 1 || periods.length <= 1)
            disableNextPeriod = true;

        var dynamicColumns = generateColumns(language, new Date(periodo.fechaInicio), new Date(periodo.fechaFin));
        var parents = await apiClient.GetParentsProjectsDataBySociedad(language, mockuser.sociedad ?? persona.sociedad, mockuser.nPersonal ?? persona.nPersonal);
        var parents_projects_vm = [];
        parents.forEach((proyecto) => {
            let item = null;

            if (proyecto.esProyectoGeneral) {
                item = {
                    value: 'PG' + proyecto.id,
                    label: `${proyecto.codigo}`,
                    name: `${proyecto.codigo}`,
                    client: '',
                    client_name: '',
                    idProyectosN2: []
                }
            } else {
                item = {
                    value: proyecto.idPep,
                    label: `${proyecto.codigo} ${proyecto.nombre}`,
                    name: proyecto.nombre,
                    client: proyecto.clienteCodigo,
                    client_name: proyecto.clienteNombre,
                    idProyectosN2: proyecto.idProyectosN2.replace(/.$/, "").split(',')
                };
            }

            parents_projects_vm.push(item);
        });
        let vmImputaciones = await getEmployeeImputations(language, req, periodo, parents_projects_vm, mockuser.sociedad ?? persona.sociedad, mockuser.nPersonal ?? persona.nPersonal);

        //setCommentReadOnly(isEditionClosed(periodo));
        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        cleanShowedInputData();

        disableButtonsEditionClosed(periodo);
        setPosition(pos);

        setDisablePreviousPeriod(disablePreviousPeriod);
        setDisableNextPeriod(disableNextPeriod);

        setPeriod(periodo);
        setDynamicColumnsGridColumns(dynamicColumns);

        setReports(vmImputaciones);
        refreshPinnedRowBottomCount(vmImputaciones);

        setLoading(false);
    };

    const goBack = () => {
        if (hayCambiosPendientes()) {
            showThereArePendingChanges();
            return;
        }

        setLoading(true);
        let mockuser_periodo = getPeriodoSession();
        let query = btoa(`periodo_inicio=${formatDateDataBase(mockuser_periodo.periodo_inicio)}&periodo_fin=${formatDateDataBase(mockuser_periodo.periodo_fin)}`);
        window.location.replace(`/timesheettasking/mockup/?${query}`);
        return;
    };

    const addRow = () => {
        if (showConsoleLogDebug)
            console.log("ReportHours.addRow()");

        if (gridApi) {
            let id = getIndiceFila();
            let rows = reports;
            let totalRows = gridApi.getDisplayedRowCount();
            let gridDiv = document.querySelector('.user-report-grid');
            //let windowHeightAux = $(window.top).height();

            //setCommentReadOnly(true);
            setComentarioReadonly(true);
            cleanShowedInputData();
            setCambiosPendientes(true);
            cleanShowedInputData();

            const newRow = {
                id: id,
                parents: parents,
                fases: [],
                codigoLabourCode: '',
                totalHoras: 0.00,
                inputs: [],
                existInDatabase: false,
                operacion: constantes.operacion.crear,
                noTieneAccesoProyecto: false,
                agrupacion_imputacion: crypto.randomUUID()
            };

            //if (windowHeight != windowHeightAux) {                
            //    AjustarAlturaTabla();
            //}

            gridApi.applyTransaction({ add: [newRow], addIndex: totalRows });

            rows.push(newRow);

            setIndiceFila(id + 1);
            setReports(rows);

            setDisableAddRow(true);
            disableBtnCancel(false);
            disableBtnSave(true);
        }
    };

    const deleteSelectedRows = () => {
        if (showConsoleLogDebug)
            console.log("ReportHours.deleteSelectedRows()");

        const selectedRows = gridApi.getSelectedRows();
        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        cleanShowedInputData();

        if (selectedRows.length > 0) {
            selectedRows.forEach((row, index, array) => {
                if (constantes.operacion.crear == row.operacion) {
                    let index = reports.findIndex(item => item.id == row.id);

                    if (index >= 0) {
                        reports.splice(index, 1);
                    }
                } else {
                    let report = reports.filter(item => item.id == row.id)[0];

                    if (!report.filaNoEditable) {
                        if (report) {
                            report.operacion = (constantes.operacion.eliminar == report.operacion) ? '' : constantes.operacion.eliminar;
                            report.inputs.forEach((input, index2, array2) => {
                                input.operacion = report.operacion;
                            });
                        }

                        row.operacion = report.operacion;
                        gridApi.applyTransaction({ update: [row] });
                    }
                }
            });

            let deleteRows = selectedRows.filter(item => constantes.operacion.crear == item.operacion);

            if (deleteRows.length > 0) {
                gridApi.applyTransaction({ remove: deleteRows });
            }

            if (gridApi.rowRenderer.rowModel.rowsToDisplay.length == 0) {
                // Si no hay filas en la tabla, deshabilito botones de guardar, cancelar y pongo a false flag de cambios.
                //disableBtnSave(true);
                disableBtnCancel(true);
                setCambiosPendientes(false);
            } else if ((reports.filter(item => 'operacion' in item && '' != item.operacion).length > 0)) {
                // Si quedan filas modificadas en la tabla, mantengo habilitados los botones de guardar, cancelar y 
                // establezco el flag de cambios a true.
                //disableBtnSave(false);
                disableBtnCancel(false);
                setCambiosPendientes(true);
            } else {
                // En otro caso, hay filas en la tabla, pero sin modificaciones, por lo que deshabilito los botones
                // de guardar y cancelar. Además establezco el flag de cambios a false.
                //disableBtnSave(true);
                disableBtnCancel(true);
                setCambiosPendientes(false);
            }

            ajustarEstadoBotonSave(reports);
            ajustarEstadoBotonAdd(reports);

            // Se habilita el botón "Añadir fila" si no hay ninguna fila nueva con proyecto, fase  y/o labour code pendiente de seleccionar.
            //let numeroCoincidencias = reports.filter(item =>
            //    constantes.operacion.crear == item.operacion
            //    && (
            //        !('pepPadreIdN1' in item)
            //        || ('pepPadreIdN1' in item && 'fase' in item && item.fase.replace(/\s/g, '').length == 0)
            //        || (!item.esProyectoGeneral && 'codigoLabourCode' in item && item.codigoLabourCode.replace(/\s/g, '').length == 0)
            //    )
            //).length;

            //if (0 == numeroCoincidencias) {
            //    setDisableAddRow(false);
            //}
        }
    };

    const cancelModifications = async () => {
        if (showConsoleLogDebug)
            console.log("ReportHours.cancelModifications()");

        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        cleanShowedInputData();
        setCambiosPendientes(false);
        setMessage(navigator.language.startsWith('es') ? 'Cargando...' : 'Loading...');
        setLoading(true);
        cleanShowedInputData();

        let existModifications = reports.reduce((inputs, item) => {
            return inputs.concat(
                item.inputs.filter(item2 => '' != item2.operacion && undefined !== item2.operacion)
                    ?? (constantes.operacion.crear == item.operacion) ? [1] : [])
        }, []).length > 0;

        if (existModifications) {
            disableBtnSave(true);
            await refillTable();
        } else {
            ajustarEstadoBotonSave(reports);
            ajustarEstadoBotonAdd(reports);
        }

        disableButtonsEditionClosed(periods[position]);
        setLoading(false);
    }

    const saveData = async () => {
        if (showConsoleLogDebug)
            console.log("ReportHours.saveData()");

        disableBtnSave(true);
        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        cleanShowedInputData();

        if (!disableAddRow) {
            setMessage(navigator.language.startsWith('es') ? 'Cargando...' : 'Loading...');
            setLoading(true);

            let req = getReq();
            let data = getModifiedData();
            let flagIsDataCorrect = isDataCorrect(data);

            if (!flagIsDataCorrect) {
                setLoading(false);
                disableBtnSave(false);
                setMessageTitle(getTranslation("reportHours.Warning"));
                setMessageContent(getTranslation('reportHours.MissingData'));
                setMessageStatus(true);
                setMessageHeaderBackground("bg-warning");

                return;
            }

            if (data.length == 0) {
                setLoading(false);
                setMessageTitle(getTranslation("reportHours.Warning"));
                setMessageContent(getTranslation('reportHours.NoChanges'));
                setMessageStatus(true);
                setMessageHeaderBackground("bg-warning");
                return;
            }

            let status = await apiClient.SaveEmployeeImputation(language, req, data);

            if (status) {
                cleanShowedInputData();
                await refillTable();

                disableBtnCancel(true);
                setMessageTitle(getTranslation("reportHours.OperationResult"));
                setMessageContent(getTranslation("reportHours.ImputationsSaved"));
                setMessageStatus(true);
                setMessageHeaderBackground("bg-success");

                setCambiosPendientes(false);
            }
            else {
                setMessageTitle(getTranslation("reportHours.OperationResult"));
                setMessageContent(getTranslation("reportHours.ImputationsNotSaved"));
                setMessageStatus(true);
                setMessageHeaderBackground("bg-danger");
                disableBtnSave(false);
            }

            setLoading(false);
        } else {
            disableBtnSave(false);
            setMessageTitle(getTranslation("reportHours.Warning"));
            setMessageContent(getTranslation('reportHours.MissingData'));
            setMessageStatus(true);
            setMessageHeaderBackground("bg-warning");
        }
    };
    /************************************************************************** Fin eventos botones */

    /************************************************************************** Eventos producidos en la tabla */
    //const onSelectionChanged = () => {
    //    // onSelectionChanged={onSelectionChanged}
    //    const selectedRows = gridApi.getSelectedRows();
    //    cleanShowedInputData();

    //    if (selectedRows.length == 1) {
    //        showRowData(selectedRows[0]);
    //    }
    //};

    const handleParentProjectChange = async (newValue, rowNode) => {
        if (showConsoleLogDebug)
            console.log("ReportHours.handleParentProjectChange()");

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        const index = reports.findIndex(r => r.id == rowNode.data.id);
        const rowData = rowNode.data; // gridApi.getRowNode(rowNode.rowIndex).data;

        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        setDisableAddRow(true);
        cleanShowedInputData();

        if (newValue == null) {
            reports[index].pepPadreId = "";
            reports[index].nombreProyecto = "";
            reports[index].fases = [];
            reports[index].fase = "";
            reports[index].nombreFase = "";
            reports[index].inputs = reports[index].inputs;
            reports[index].cliente = "0000000000";
            reports[index].nombreCliente = "-";
            reports[index].esProyectoGeneral = false;
            reports[index].idProyectosN2 = [];
        }
        else {
            let childrens_projects_vm = await getChildrenProjectsDataByProjectSocietyAndEmplazamiento(newValue.value, mockuser.sociedad ?? persona.sociedad, newValue.esProyectoGeneral, mockuser.nPersonal ?? persona.nPersonal);

            reports[index].pepPadreIdN1 = newValue.value;
            reports[index].nombreProyecto = newValue.name;
            reports[index].fase = '';
            reports[index].fases = childrens_projects_vm;
            reports[index].nombreFase = "";
            reports[index].inputs = reports[index].inputs;
            reports[index].clienteCodigo = newValue.client;
            reports[index].clienteNombre = newValue.client_name;
            reports[index].esProyectoGeneral = newValue.esProyectoGeneral;
            reports[index].idProyectosN2 = [];
        }

        if (constantes.operacion.crear != rowData.operacion && constantes.operacion.eliminar != rowData.operacion) {
            rowData.operacion = constantes.operacion.actualizar;
            reports[index].inputs.forEach(item => item.operacion = constantes.operacion.actualizar);
        }

        ajustarEstadoBotonSave(reports);
        ajustarEstadoBotonAdd(reports);

        if (null == newValue || newValue.esProyectoGeneral) {
            reports[index].codigoLabourCode = "";
            reports[index].nombreLabourCode = "";
        }     

        showRowData(reports[index]);

        disableBtnCancel(false);
        //disableBtnSave(false);
        setReports(reports);
        gridApi.applyTransaction({ update: [rowData] });
        gridApi.redrawRows({ rowNodes: [rowNode] });
    };

    const handleChildrenProjectChange = (newValue, rowNode) => {
        if (showConsoleLogDebug)
            console.log("ReportHours.handleChildrenProjectChange()");

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        const index = reports.findIndex(r => r.id == rowNode.data.id);
        const rowData = rowNode.data;

        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        cleanShowedInputData();

        if (newValue == null) {
            reports[index].fase = "";
            reports[index].nombreFase = "";
            reports[index].inputs = reports[index].inputs;
            reports[index].cliente = "0000000000";
            reports[index].nombreCliente = "-";

            setDisableAddRow(true);
        }
        else {
            let estado = checkDataSelection(reports[index].id, reports[index].pepPadreIdN1, newValue.value, reports[index].codigoLabourCode, reports[index].esProyectoGeneral);

            if (!estado) {
                return;
            }
            console.log(reports[index]);
            console.log(newValue);
            reports[index].fase = newValue.value;
            reports[index].nombreFase = newValue.name;
            reports[index].inputs = reports[index].inputs;
            reports[index].clienteCodigo = newValue.client;
            reports[index].clienteNombre = newValue.client_name;

            //if (reports[index].pepPadreIdN1.length > 0 && reports[index].codigoLabourCode.length > 0 && reports[index].fase.length > 0) {
            //    setDisableAddRow(false);
            //    disableBtnSave(false);
            //} else {
            //    setDisableAddRow(true);
            //    disableBtnSave(true);
            //}
            //ajustarEstadoBotonAdd(reports[index].pepPadreIdN1, reports[index].codigoLabourCode, reports[index].fase, reports[index].esProyectoGeneral);            
        }

        if (constantes.operacion.eliminar != rowData.operacion && constantes.operacion.crear != rowData.operacion) {
            rowData.operacion = constantes.operacion.actualizar;
            reports[index].inputs.forEach(item => item.operacion = constantes.operacion.actualizar);
        }

        ajustarEstadoBotonSave(reports);
        ajustarEstadoBotonAdd(reports);

        showRowData(reports[index]);

        disableBtnCancel(false);
        setReports(reports);
        gridApi.applyTransaction({ update: [rowData] });
    }

    const handleLabourCodeChange = (newValue, rowNode) => {
        if (showConsoleLogDebug)
            console.log("ReportHours.handleChildrenProjectChange()");

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        const index = reports.findIndex(r => r.id == rowNode.data.id);
        const rowData = rowNode.data; // gridApi.getRowNode(rowNode.rowIndex).data;

        //setCommentReadOnly(true);
        setComentarioReadonly(true);
        cleanShowedInputData();

        if (newValue == null) {
            reports[index].codigoLabourCode = "";
            reports[index].nombreLabourCode = "";

            setDisableAddRow(true);
        }
        else {
            let estado = checkDataSelection(reports[index].id, reports[index].pepPadreIdN1, reports[index].fase, newValue.value, reports[index].esProyectoGeneral);

            if (!estado) {
                return;
            }
            console.log(reports[index]);
            console.log(newValue);

            reports[index].codigoLabourCode = newValue.value;
            reports[index].nombreLabourCode = labourCodes.filter(item => item.value == newValue.value)[0]?.name;

            //if (reports[index].pepPadreIdN1.length > 0 && reports[index].codigoLabourCode.length > 0 && reports[index].fase.length > 0) {
            //    setDisableAddRow(false);
            //    disableBtnSave(false);
            //} else {
            //    setDisableAddRow(true);
            //    disableBtnSave(true);
            //}
            //ajustarEstadoBotonAdd(reports[index].pepPadreIdN1, reports[index].codigoLabourCode, reports[index].fase, reports[index].esProyectoGeneral);            
        }

        if (constantes.operacion.eliminar != rowData.operacion && constantes.operacion.crear != rowData.operacion) {
            rowData.operacion = constantes.operacion.actualizar;
            reports[index].inputs.forEach(item => item.operacion = constantes.operacion.actualizar);
        }

        ajustarEstadoBotonSave(reports);
        ajustarEstadoBotonAdd(reports);

        showRowData(reports[index]);

        disableBtnCancel(false);
        setReports(reports);
        gridApi.applyTransaction({ update: [rowData] });
    }
    /************************************************************************** Fin eventos producidos en la tabla */

    /************************************************************************** Eventos visualizar información imputación */
    const infoComentarioChange = () => {
        if (showConsoleLogDebug)
            console.log("ReportHours.infoComentarioChange()");

        let i = infoComentario.current.idReport;

        if (undefined === i) {
            return;
        }

        let inputId = infoComentario.current.inputId;

        if (-1 == inputId) {
            infoComentario.current.value = '';
            return;
        }

        let report = reports[i];
        let reportInput = report.inputs.find(objeto => objeto.id === inputId);

        reportInput.comentario = infoComentario.current.value;

        if (constantes.operacion.crear != reportInput.operacion && constantes.operacion.eliminar != reportInput.operacion) {
            report.operacion = constantes.operacion.actualizar;
            reportInput.operacion = report.operacion;

            let row = gridApi.rowRenderer.rowModel.rowsToDisplay.map(item => item.data).filter(item => item.id == i)[0];
            row.operacion = report.operacion;
            gridApi.applyTransaction({ update: [row] });
        }

        disableBtnCancel(false);
        disableBtnSave(false);

        if (showConsoleLogDebug) console.log(`i: ${i} inputId: ${inputId} comentario: ${infoComentario.current.value}`);
    }
    /************************************************************************** Fin eventos visualizar información imputación */

    /************************************************************************** Resto de funciones */
    const getTranslation = (label) => {
        if (showConsoleLogDebug)
            console.log("ReportHours.GetTranslations2()");

        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };

    const getReq = () => {
        let nPersonalMockuser = getMockuserSession();

        if ("null" == nPersonalMockuser || null == nPersonalMockuser || undefined === nPersonalMockuser) {
            nPersonalMockuser = searchParams.get('mockuser');
            setMockuserSession(nPersonalMockuser);
        }

        return {
            email: userLogged.mail,
            token: userLogged.token,
            nPersonalMockuser: nPersonalMockuser
        };
    }

    const toPage = (page) => {
        history.push(page);
    };

    const getEmployeeImputations = async (language, req, period, projects, sociedad, npersonal) => {
        if (showConsoleLogDebug)
            console.log("ReportHours.getEmployeeImputations()");

        var imputaciones = await apiClient.GetEmployeeImputation(language, req, period);
        var vmImputaciones = [];
        var id = 0;
        setIndiceFila(id);

        vmImputaciones = imputaciones.reduce(async (reportes, imputacion) => {
            if (constantes.estado.validado == imputacion.idEstado) {
                setFlag('flagValidated', true);
                //setCommentReadOnly(isEditionClosed(period));
                //setCommentReadOnly(true);
                setComentarioReadonly(true);
            }

            let proyecto = (await reportes).find(p => p.fase === imputacion.proyecto && p.codigoLabourCode == imputacion.codigoLabourCode && p.agrupacion_imputacion == imputacion.agrupacion_imputacion);

            if (!proyecto) {
                let fases = await getChildrenProjectsDataByProjectSocietyAndEmplazamiento(imputacion.pepPadreId, sociedad, imputacion.esPG, npersonal);
                console.log(`>>> imputacion:`);
                console.log(imputacion);
                let proyectosCoincidentes = projects.filter(p => (imputacion.esPG && p.value == imputacion.pepPadreId) || (!imputacion.esPG && p.idProyectosN2.includes(imputacion.pepPadreId)));
                let fasesCoincidentes = fases.filter(f => f.value == imputacion.proyecto);
                let noTieneAccesoProyecto = (proyectosCoincidentes.length == 0 || fasesCoincidentes.length == 0) ? true : false;
                let nombreProyecto = (proyectosCoincidentes.length > 0) ? proyectosCoincidentes[0].name : '';
                let nombreFase = (fasesCoincidentes.length > 0) ? fasesCoincidentes[0].name : '';
                let nombreCliente = (fasesCoincidentes.length > 0) ? fasesCoincidentes[0].client_name : '';

                proyecto = {
                    id: id++,
                    pepPadreId: imputacion.pepPadreId,
                    pepPadreIdN1: imputacion.pepPadreIdN1,
                    fase: imputacion.proyecto,
                    totalHoras: 0.00,
                    inputs: [],
                    existInDatabase: true,
                    fases: fases,
                    nombreProyecto: nombreProyecto,
                    nombreFase: nombreFase,
                    clienteCodigo: imputacion.cliente,
                    clienteNombre: nombreCliente,
                    codigoLabourCode: imputacion.codigoLabourCode,
                    nombreLabourCode: imputacion.nombreLabourCode,
                    esProyectoGeneral: imputacion.esPG,
                    agrupacion_imputacion: imputacion.agrupacion_imputacion,
                    noTieneAccesoProyecto: noTieneAccesoProyecto,
                    filaNoEditable: false
                };

                (await reportes).push(proyecto);
            }

            proyecto.totalHoras = (parseFloat(proyecto.totalHoras) + imputacion.horas).toFixed(2);
            proyecto.filaNoEditable = (constantes.estado.sap == imputacion.idEstado || new Date(period.fechaCierre) < new Date()) ? true : proyecto.filaNoEditable;

            proyecto.inputs.push({
                id: imputacion.id,
                date: formatDateDataBase(imputacion.fechaImputacion),
                input: imputacion.horas,
                idComentario: imputacion.idComentario,
                comentario: imputacion.comentario,
                agrupacion_imputacion: imputacion.agrupacion_imputacion,
                noTieneAccesoProyecto: proyecto.noTieneAccesoProyecto,
                filaNoEditable: proyecto.filaNoEditable
            });

            setIndiceFila(id);

            return await reportes;
        }, []);

        return vmImputaciones;
    };

    const getTotalHoursOfReportI = (i) => {
        let total = reports[i].inputs.reduce((total, i) => {
            total += parseFloat(i.input);

            return total;
        }, 0);

        return total;
    };

    const getTotalHoursByDate = (date) => {
        let total = reports.reduce((total, p) => {
            let input = p.inputs.filter(i => i.date == date)[0];
            total += (input)
                ? parseFloat(input.input)
                : 0;

            return total;
        }, 0);

        return total;
    };

    const checkTotalHoursColumnDay = (reportInput, newValue, fecha) => {
        let horasTotalesColumna = reports.map(item1 => item1.inputs
            .filter(item2 => (undefined === reportInput || item2.id != reportInput.id) && item2.date == fecha)
            .map(item2 => item2.input))
            .join(',')
            .split(',')
            .reduce((total, valor) => total + Number(valor), 0);

        if ((horasTotalesColumna + Number(newValue)) > 24) {
            setMessageTitle('');
            setMessageContent(getTranslation('reportHours.ImputationsDayExceed24Hours'));
            setMessageStatus(true);
            setMessageHeaderBackground('bg-danger');

            return false;
        }

        return true;
    }

    const getReportsTotalHours = () => {
        if (showConsoleLogDebug) console.log("ReportHours.getReportsTotalHours()");

        let total = 0;

        if (reports.length > 0) {
            if (showConsoleLogDebug) console.log(reports);

            gridApi.forEachNode((rowNode, index) => {

                if (null != document.getElementById(`fila_${rowNode.data.id}`)) {
                    total += parseFloat(document.getElementById(`fila_${rowNode.data.id}`).innerHTML);
                } else {
                    total += parseFloat(rowNode.data?.totalHoras ?? 0);
                }
            });
        }

        if (showConsoleLogDebug) console.log("Total: " + total);
        return total;
    };

    const getModifiedData = () => {
        let data = [];

        for (var i = 0; i < reports.length; i++) {
            let report = reports[i];

            for (var j = 0; j < report.inputs.length; j++) {
                let input = report.inputs[j];

                if (undefined !== input.operacion && '' != input.operacion) {
                    data.push({
                        id: input.id,
                        idEstado: 1,
                        proyecto: report.fase,
                        codigoLabourCode: report.codigoLabourCode,
                        nPersonal: userLogged.pernr,
                        horas: Number(input.input),
                        cliente: report.clienteCodigo,
                        idComentario: input.idComentario,
                        comentario: input.comentario,
                        fechaImputacion: input.date,
                        existInDatabase: report.existInDatabase,
                        esPG: report.esProyectoGeneral,
                        operacion: input.operacion,
                        agrupacion_imputacion: report.agrupacion_imputacion
                    });
                }
            }
        }

        return data;
    }

    const isDataCorrect = (data) => {
        let flag = true;

        for (var i = 0; i < data.length; i++) {
            let item = data[i];

            if ((item.proyecto == null || item.proyecto == undefined || item.proyecto.length == 0)
                || (!item.esPG && (item.codigoLabourCode == null || item.codigoLabourCode == undefined || item.codigoLabourCode.length == 0))) {

                flag = false;
                break;
            }
        }

        return flag;
    }

    const refillTable = async () => {
        var req = getReq();
        let vmImputaciones = await getEmployeeImputations(language, req, period, parents, mockuser.sociedad ?? persona.sociedad, mockuser.nPersonal ?? persona.nPersonal);
        setReports(vmImputaciones);
    }

    const setHours = (params) => {
        if (showConsoleLogDebug) console.log("ReportHours.setHours()");
        let disable = false;

        setDisableAddRow(disable);
    };

    const checkDataSelection = (id, proyectoId, faseId, codigoLabourCode, esProyectoGeneral) => {
        let estado = true;

        if (undefined !== proyectoId && undefined !== faseId && proyectoId.length > 0 && faseId.length > 0 && esProyectoGeneral) {

            for (var i = 0; i < reports.length; i++) {
                let report = reports[i];

                if (report.id != id && report.pepPadreIdN1 == proyectoId && report.fase == faseId && ((!esProyectoGeneral && report.codigoLabourCode == codigoLabourCode) || esProyectoGeneral)) {
                    estado = false;
                    break;
                }
            }

            if (!estado) {
                setMessageTitle('');
                setMessageContent((!esProyectoGeneral) ? getTranslation('reportHours.CombinationExists') : getTranslation('reportHours.PGCombinationExists'));
                setMessageStatus(true);
                setMessageHeaderBackground('bg-danger');
            }
        }

        //if (undefined !== proyectoId && undefined !== faseId && proyectoId.length > 0 && faseId.length > 0
        //    && (esProyectoGeneral || (!esProyectoGeneral && undefined !== codigoLabourCode && codigoLabourCode.length > 0))) {

        //    for (var i = 0; i < reports.length; i++) {
        //        let report = reports[i];

        //        if (report.id != id && report.pepPadreIdN1 == proyectoId && report.fase == faseId && ((!esProyectoGeneral && report.codigoLabourCode == codigoLabourCode) || esProyectoGeneral)) {
        //            estado = false;
        //            break;
        //        }
        //    }

        //    if (!estado) {
        //        setMessageTitle('');
        //        setMessageContent((!esProyectoGeneral) ? getTranslation('reportHours.CombinationExists') : getTranslation('reportHours.PGCombinationExists'));
        //        setMessageStatus(true);
        //        setMessageHeaderBackground('bg-danger');
        //    }
        //}

        return estado;
    };

    const getChildrenProjectsDataByProjectSocietyAndEmplazamiento = async (parentId, sociedad, esProyectoGeneral, npersonal) => {
        let childrens = await apiClient.getChildrenProjectsDataByProjectSocietyAndEmplazamiento(language, parentId, sociedad, esProyectoGeneral, npersonal);
        let childrens_projects_vm = Array.from(
            new Set(childrens.map((x) => x.id))
        ).map((id) => {
            let children = childrens.find((x) => x.id === id);

            return {
                value: children.idPep,
                label: `${children.codigo} ${children.nombre}`,
                name: (!children.esProyectoGeneral) ? children.nombre : children.codigo,
                client: children.clienteCodigo,
                client_name: children.clienteNombre
            };
        });

        return childrens_projects_vm;
    }

    const refreshPinnedRowBottomCount = (imputaciones) => {
        if (showConsoleLogDebug)
            console.log("ReportHours.refreshPinnedRowBottomCount()");

        let total = getReportsTotalHours();
        document.getElementById('fila_resumen_horas_totales').innerHTML = total.toFixed(2); // totalHoras.toFixed(2);
    };

    const disableBtnCancel = (status) => {
        document.getElementById('btnCancel').disabled = status;
    }

    const disableBtnSave = (status) => {
        document.getElementById('btnSave').disabled = status;
    }

    const disableButtonsEditionClosed = (period) => {
        if (isEditionClosed(period)) {
            setDisableAddRow(true);
            disableBtnCancel(true);
            disableBtnSave(true);
            setDisableDeleteRow(true);
        }
        else {
            setDisableAddRow(false);
            disableBtnCancel(true);
            disableBtnSave(true);
            setDisableDeleteRow(false);
        }
    }

    //const ajustarEstadoBotonAdd = function (pepPadreIdN1, codigoLabourCode, fase, esProyectoGeneral) {
    //    if (pepPadreIdN1.length > 0 && fase.length > 0 && (esProyectoGeneral || (!esProyectoGeneral && codigoLabourCode.length > 0))) {
    //        setDisableAddRow(false);
    //        /*disableBtnSave(false);*/
    //    } else {
    //        setDisableAddRow(true);
    //        /*disableBtnSave(true);*/
    //    }
    //}

    const ajustarEstadoBotonAdd = (pReports) => {
        let filasNuevas = reports.filter((item) => constantes.operacion.crear == item.operacion);
        let flag = comprobarDatosCompletos(filasNuevas);
        setDisableAddRow(!flag);
    }

    const ajustarEstadoBotonSave = (pReports) => {
        let flag = comprobarDatosCompletos(pReports);

        if (flag) {
            let datosModificados = getModifiedData();

            if (datosModificados.length == 0) {
                flag = false;
            }
        }

        disableBtnSave(!flag);
    }

    // true: datos correctos; false: faltan datos.
    const comprobarDatosCompletos = (pReports) => {
        var flag = true;

        for (var i = 0; i < pReports.length; i++) {
            let data = pReports[i];

            if ((data.fase == null || data.fase == undefined || data.fase.length == 0)
                || (!data.esProyectoGeneral && (data.codigoLabourCode == null || data.codigoLabourCode == undefined || data.codigoLabourCode.length == 0))) {

                flag = false;
                break;
            } else if (data.inputs.length == 0) {
                flag = false;
                break;
            }
        }

        return flag;
    }

    const isEditionClosed = (period) => {
        //return constantes.estado.cerrado == period.idEstado;
        let flagValidated = getFlag('flagValidated');
        let flagIsMockuser = getFlag('isMockuser');
        console.log(`>>> flagValidated: ${flagValidated} / flagIsMockuser: ${flagIsMockuser}`);

        return (flagIsMockuser && new Date(period.fechaCierre) < new Date())                        // Comprobación para el mánager (mock user)
            || (!flagIsMockuser && (flagValidated || new Date(period.fechaCierre) < new Date()));   // Comprobación para el profesional.
    }

    const cleanShowedInputData = () => {
        infoProyecto.current.innerHTML = '';
        infoFase.current.innerHTML = '';
        infoLabourCode.current.innerHTML = '';
        infoCliente.current.innerHTML = '';
        infoHoras.current.innerHTML = '';
        infoFecha.current.innerHTML = '';
        infoComentario.current.value = '';
        infoComentario.current.idReport = undefined;
    }

    const showRowData = (report) => {
        // Mostrar información en la zona inferior.
        infoProyecto.current.innerHTML = (undefined == report.nombreProyecto) ? '' : report.nombreProyecto;
        infoFase.current.innerHTML = (undefined == report.nombreFase) ? '' : report.nombreFase;
        infoLabourCode.current.innerHTML = (undefined == report.nombreLabourCode) ? '' : report.nombreLabourCode;
        infoCliente.current.innerHTML = (undefined == report.clienteCodigo || undefined == report.clienteNombre) ? '' : report.clienteNombre;
    }

    const showThereArePendingChanges = () => {
        setMessageTitle(getTranslation('reportHours.Warning'));
        setMessageContent(getTranslation('reportHours.PendingChanges'));
        setMessageStatus(true);
        setMessageHeaderBackground("bg-warning");
    }

    const setComentarioReadonly = (estado) => {
        console.log("setComentarioReadonly() " + estado);
        $('#txtComentario').prop('readonly', estado);
    }
    /************************************************************************** Fin resto de funciones */

    /************************************************************************** Utils */
    function formatDateNumber(num) {
        return num.toString().padStart(2, '0');
    }

    const formatDateString = (date) => {
        var formatDate = [formatDateNumber(date.getDate()), formatDateNumber(date.getMonth() + 1), date.getFullYear()].join('/');
        return formatDate;
    };

    const formatDateDataBase = (date) => {
        var dateToFormat = new Date(date);
        var formatDate = [dateToFormat.getFullYear(), formatDateNumber(dateToFormat.getMonth() + 1), formatDateNumber(dateToFormat.getDate())].join('-');
        return formatDate;
    };
    /************************************************************************** Fin Utils */

    return (
        <div>
            {
                loading &&
                <Loading show={loading} message={message} />
            }

            <ModalMessage
                title={messageTitle}
                message={messageContent}
                show={messageStatus}
                setMessageStatus={setMessageStatus}
                headerBackground={messageHeaderBackground}
                btnCloseText={getTranslation("reportHours.Close")}
            />

            <div>
                <section>
                    <h5 className={!isMockuser ? "" : "hidden"}>{getTranslation('reportHours.Title')}</h5>
                    <h5 className={isMockuser ? "" : "hidden"}>{getTranslation('reportHours.TitleMockuser')} {mockuser.nombre}  {mockuser.apellido1} {mockuser.apellido2}</h5>
                </section>

                <section>
                    <div className="table-container">
                        <Row between="xs" className="row">
                            <Col xs={4}>
                                <div id="goToPreviousWeek">
                                    <h4>
                                        <b>{getTranslation('reportHours.Period')} </b>
                                        <button className="icon-week-button" disabled={disablePreviousPeriod} onClick={goToPreviousWeek}>
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                                        </button>
                                    </h4>
                                </div>
                                <div id="week">
                                    <label>
                                        <h4>{formatDateString(new Date(period.fechaInicio))} - {formatDateString(new Date(period.fechaFin))}</h4>
                                    </label>
                                </div>
                                <div id="goToNextWeek">
                                    <h4>
                                        <button className="icon-week-button" disabled={disableNextPeriod} onClick={goToNextWeek}>
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </button>
                                    </h4>
                                </div>
                            </Col>
                            <Col xs={3}>
                                <h4>{getTranslation('reportHours.PeriodStatus')}: {period.estado}</h4>
                            </Col>
                            <Col xs={2} />
                            <Col xs={3}>
                                <h4 id="statusLabelAlign">{getTranslation('reportHours.Status')}: {period.estado}</h4>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section>
                    <div className="table-container mb-2">
                        <Row between="xs" className="row">
                            <Col xs={4}>
                                <div className="botonera-container">
                                    <span>
                                        <button className={isMockuser ? "btn btn-primary mr-1" : "hidden"} onClick={goBack}>{getTranslation('reportHours.Volver')}</button>
                                    </span>
                                    <span>
                                        <button className="btn mr-1" disabled={disableAddRow} onClick={addRow}>{getTranslation('reportHours.AddRow')}</button>
                                    </span>
                                    <span>
                                        <button className="btn" disabled={disableDeleteRow} onClick={deleteSelectedRows}>{getTranslation('reportHours.DeleteRow')}</button>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={5} />
                            <Col xs={3}>
                                <div className="botonera-container float-right">
                                    <button id="btnCancel" className="btn" onClick={cancelModifications}>{getTranslation('reportHours.Cancel')}</button>
                                    <button id="btnSave" className="btn ml-1" onClick={saveData}>{getTranslation('reportHours.Save')}</button>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="table-container">
                        <Row between="xs" className="row">
                            <Col xs={12} className="espacio-imputaciones">
                                <div className="user-report-grid ag-theme-alpine">
                                    <AgGridReact
                                        domLayout={domLayout}
                                        pagination={false}
                                        sizeColumnsToFit={true}
                                        columnDefs={getGridColumns()}
                                        rowData={reports}
                                        rowSelection={'multiple'}
                                        pinnedBottomRowData={gridBottomRows}
                                        //suppressRowClickSelection={true}
                                        stopEditingWhenCellsLoseFocus={true}
                                        getRowStyle={(params) => {
                                            if (params.node.rowIndex % 2 === 0) {
                                                return { background: '#ececec' };
                                            }
                                        }}
                                        defaultColDef={{
                                            width: 170,
                                            sortable: true
                                        }}
                                        onGridReady={onGridReady}
                                        onCellValueChanged={params => {
                                            setHours(params);
                                            //refreshPinnedRowBottomCount();
                                        }}
                                        onRowDataUpdated={() => { refreshPinnedRowBottomCount(); }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section>
                    <div>
                        <br />
                    </div>
                </section>

                <section>
                    <div className="table-container">
                        <Row between="xs" className="row">
                            <Col xs={8}>
                                <div className="table-container">
                                    <Row between="xs" className="row">
                                        <Col xs={6}>
                                            <b>{getTranslation('reportHours.Project')}:</b> <span ref={infoProyecto}></span>
                                        </Col>
                                        <Col xs={6}>
                                            <span ref={infoFecha}></span>
                                        </Col>
                                    </Row>
                                    <Row between="xs" className="row">
                                        <Col xs={6}>
                                            <b>{getTranslation('reportHours.Phase')}:</b> <span ref={infoFase}></span>
                                        </Col>
                                        <Col xs={6}>
                                            <b>{getTranslation('reportHours.Hours')}:</b> <span ref={infoHoras}></span>
                                        </Col>
                                    </Row>
                                    <Row between="xs" className="row">
                                        <Col xs={6}>
                                            <b>{getTranslation('reportHours.LabourCode')}:</b> <span ref={infoLabourCode}></span>
                                        </Col>
                                        <Col xs={6}>
                                            &nbsp;
                                        </Col>
                                    </Row>
                                    <Row between="xs" className="row">
                                        <Col xs={6}>
                                            <b>{getTranslation('reportHours.Client')}:</b> <span ref={infoCliente}></span>
                                        </Col>
                                        <Col xs={3}>
                                            <Select
                                                id="commentSelector"
                                                placeholder="comments"
                                                defaultValue={parents[0]}
                                                isClearable={true}
                                                isSearchable={true}
                                                options={parents}
                                                styles={{ menuPortal: provided => ({ ...provided, zIndex: 5 }) }}
                                                className="d-none"
                                            />
                                        </Col>
                                        <Col xs={3} />
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={4}>
                                <div className="mt-1">
                                    <textarea
                                        id="txtComentario"
                                        ref={infoComentario}
                                        onChange={infoComentarioChange}
                                        placeholder={getTranslation('reportHours.Comments')}
                                        style={{ width: '100%' }}
                                        rows={3}
                                        maxLength={1000}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    );

}

export default ReportHours;